import * as R from 'ramda'
import React from 'react'
import { Link } from 'react-router-dom'

/**
 * CrossAppLink component handles navigation between the React app and Next.js apps.
 * It automatically detects if a route should be handled by a different application
 * and uses appropriate navigation method.
 */
const CrossAppLink = ({ to, children, onClick, ...props }) => {
  // Routes that should trigger full page navigation (handled by different apps)
  const externalRoutes = [
    '/order/', // All order routes handled by next-shop
  ]
  
  // Check if the link is to an external route
  const isExternalRoute = R.any(route => R.includes(route, to))(externalRoutes)
  
  const handleClick = (e) => {
    // Log navigation for debugging
    if (isExternalRoute) {
      console.log('[CrossAppLink] External navigation detected:', {
        to,
        type: 'full-page-navigation',
        timestamp: new Date().toISOString()
      })
    } else {
      console.log('[CrossAppLink] Internal navigation:', {
        to,
        type: 'react-router',
        timestamp: new Date().toISOString()
      })
    }
    
    // Call onClick if provided
    if (onClick) {
      onClick(e)
    }
  }
  
  if (isExternalRoute) {
    // Use standard anchor for cross-app navigation
    // This will trigger a full page load, allowing nginx to route to the correct app
    return (
      <a 
        href={to} 
        onClick={handleClick}
        {...props}
      >
        {children}
      </a>
    )
  }
  
  // Use React Router for internal navigation within the React app
  return (
    <Link 
      to={to} 
      onClick={handleClick}
      {...props}
    >
      {children}
    </Link>
  )
}

export default CrossAppLink